"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var BallGames = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(BallGames, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(BallGames);

  function BallGames() {
    (0, _classCallCheck2["default"])(this, BallGames);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BallGames, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M2.34,14.6349597 C2.94,14.4149597 3.56,14.3049597 4.22,14.3049597 C5.56,14.3049597 6.73,14.7249597 7.73,15.5649597 L4.59,18.7049597 C3.53,17.5049597 2.78,16.1349597 2.34,14.6349597 L2.34,14.6349597 Z M15.56,9.80495969 C17.53,11.2749597 19.66,11.6349597 21.94,10.8849597 C21.97,11.0949597 22,11.4749597 22,12.0049597 C22,13.0349597 21.75,14.1849597 21.28,15.4549597 C20.81,16.7149597 20.23,17.7349597 19.55,18.5049597 L13.22,12.1949597 L15.56,9.80495969 L15.56,9.80495969 Z M8.77,16.6449597 C9.83,18.1749597 10.05,19.8449597 9.42,21.6649597 C8,21.2549597 6.73,20.6149597 5.67,19.7349597 L8.77,16.6449597 L8.77,16.6449597 Z M12.19,13.2249597 L18.5,19.5549597 C16.33,21.4549597 13.78,22.2549597 10.88,21.9449597 C11.09,21.2849597 11.2,20.5649597 11.2,19.7849597 C11.2,19.1649597 11.06,18.4349597 10.78,17.6049597 C10.5,16.7749597 10.17,16.0949597 9.8,15.5649597 L12.19,13.2249597 L12.19,13.2249597 Z M8.81,14.5049597 C7.88,13.6749597 6.8,13.1549597 5.58,12.9149597 C4.36,12.6849597 3.19,12.7549597 2.06,13.1349597 C2.03,12.9149597 2,12.5349597 2,12.0049597 C2,10.9749597 2.25,9.82495969 2.72,8.55495969 C3.19,7.29495969 3.77,6.27495969 4.45,5.50495969 L11.11,12.1949597 L8.81,14.5049597 L8.81,14.5049597 Z M15.56,7.73495969 C14.22,6.08495969 13.91,4.28495969 14.63,2.34495969 C15.25,2.50495969 15.96,2.80495969 16.76,3.26495969 C17.55,3.71495969 18.2,4.16495969 18.7,4.59495969 L15.56,7.73495969 L15.56,7.73495969 Z M21.66,9.38495969 C21.06,9.59495969 20.44,9.70495969 19.78,9.70495969 C18.69,9.70495969 17.64,9.38495969 16.64,8.72495969 L19.73,5.67495969 C20.61,6.77495969 21.25,8.00495969 21.66,9.38495969 L21.66,9.38495969 Z M12.19,11.1149597 L5.5,4.45495969 C7.67,2.55495969 10.22,1.75495969 13.13,2.06495969 C12.91,2.72495969 12.8,3.44495969 12.8,4.22495969 C12.8,4.94495969 12.96,5.75495969 13.29,6.66495969 C13.62,7.56495969 14,8.28495969 14.5,8.81495969 L12.19,11.1149597 Z"
      }));
    }
  }]);
  return BallGames;
}(_react["default"].PureComponent);

var _default = BallGames;
exports["default"] = _default;